// FETCH ALL PROPERTIES FROM PROPERTY MASTER
export const FETCH_NAVIGATION_REQUEST = 'FETCH_NAVIGATION_REQUEST';
export const FETCH_NAVIGATION_SUCCESS = 'FETCH_NAVIGATION_SUCCESS';
export const FETCH_NAVIGATION_FAILURE = 'FETCH_NAVIGATION_FAILURE';
